// File: src/pages/Services.jsx

import { motion } from "framer-motion";
import { Globe2, BarChart3, Building2, Cpu, Megaphone } from "lucide-react";
import AdvisoryCouncilsSection from "../Components/HomePageComponents/AdvisoryCounsilSection";

// Added images to each service (related to those from ServicesSection.js context)
const services = [
  {
    icon: <Globe2 className="w-14 h-14 text-blue-700" />,
    title: "Global Business Matchmaking",
    desc: "Connecting investors, corporations, and institutions across India and Europe through curated, high-value relationships built on strategic alignment and cultural understanding.",
    image: "/Images/image16.jpeg",
  },
  {
    icon: <BarChart3 className="w-14 h-14 text-blue-700" />,
    title: "Market Intelligence & Economic Research",
    desc: "Delivering exclusive market insights, sector studies, and economic analysis to empower businesses with data-driven strategies and global foresight.",
    image: "/Images/image19.jpeg",
  },
  {
    icon: <Building2 className="w-14 h-14 text-blue-700" />,
    title: "Strategic Expansion & Delegation Support",
    desc: "Providing hands-on assistance for international expansion—trade missions, stakeholder introductions, and legal facilitation for seamless market entry.",
    image: "/Images/image20.jpeg",
  },
  {
    icon: <Cpu className="w-14 h-14 text-blue-700" />,
    title: "Digital Transformation & Innovation Support",
    desc: "Helping members adopt digital-first strategies with e-commerce, AI, blockchain, and sustainability solutions aligned with EU and Digital India initiatives.",
    image: "/Images/image27.jpeg",
  },
  {
    icon: <Megaphone className="w-14 h-14 text-blue-700" />,
    title: "Policy Advocacy & Thought Leadership",
    desc: "Engaging with ministries, trade bodies, and global councils to advocate for innovation-led growth and ease of doing business across borders.",
    image: "/Images/image4.jpeg",
  },
];

export default function Services() {
  return (
    <section className="bg-gray-50 min-h-screen text-gray-800">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-800 to-indigo-900 text-white py-28 text-center px-6">
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-6xl  font-Agatho_Regular  font-bold mb-6"
        >
          Enabling Growth Through Insight, Connection & Strategy
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="max-w-3xl mx-auto text-lg md:text-xl leading-relaxed"
        >
          Empowering businesses to thrive in a globally connected world through
          strategic matchmaking, data-driven insights, and cross-border
          collaboration.
        </motion.p>
      </div>

      {/* Services Section (No Grid, Pure Flex) */}
      <div className="max-w-7xl mx-auto py-24 px-6 flex flex-wrap justify-center gap-12">
        {services.map((service, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
            className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition duration-300 p-10 flex flex-col justify-between w-full sm:w-[45%] lg:w-[30%] min-h-[480px]"
          >
            <div className="flex flex-col items-start space-y-6">
              {/* Service Image */}
              <div className="w-full h-48 bg-gray-100 rounded-xl mb-4 flex items-center justify-center overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="object-cover w-full h-full rounded-xl"
                  style={{ objectPosition: "center" }}
                />
              </div>

              {service.icon}
              <h3 className="text-3xl  font-Agatho_Regular  font-semibold text-gray-900">
                {service.title}
              </h3>
              <p className="text-gray-600 text-base leading-relaxed">
                {service.desc}
              </p>
            </div>

            <div className="mt-8">
              <a
                href="/contact"
                className="text-blue-700 font-semibold border-2 border-blue-700 px-6 py-3 rounded-lg hover:bg-blue-700 hover:text-white transition inline-block text-center"
              >
                Contact Us →
              </a>
            </div>
          </motion.div>
        ))}
      </div>

      <AdvisoryCouncilsSection />

      {/* Call to Action */}
      <div className="bg-blue-900 text-white py-20 text-center px-6">
        <h2 className="text-4xl  font-Agatho_Regular  font-semibold mb-5">
          Join the Movement <span>-</span> Build the Future of Indo European
          Business
        </h2>
        <p className="max-w-3xl mx-auto mb-8 text-blue-100 text-lg">
          Be part of a dynamic community of leaders, innovators, and
          changemakers. Together, we’re shaping a more resilient, inclusive, and
          interconnected future.
        </p>
        <a
          href="/contact"
          className="bg-white text-blue-900 font-semibold px-8 py-4 rounded-lg text-lg hover:bg-blue-100 transition inline-block"
        >
          Become a Member
        </a>
   
      </div>

      {/* Contact Info */}
      {/* <footer className="bg-gray-900 text-gray-300 py-10 text-center text-sm">
        <div className="max-w-4xl mx-auto space-y-3">
          <p>📍 New Market, Sandigo, California</p>
          <p>📧 iebc@indoeuropeancouncil.eu | 🕒 9:10 AM - 5:30 PM</p>
          <p>© 2025 Indo European Business Council. All rights reserved.</p>
        </div>
      </footer> */}
    </section>
  );
}
